import useOtpVerify from './useOtpVerify.hook';

export { useOtpVerify };
